import { Layout } from "../components/Layout";
import { useReveal } from "../useReveal";

export default function Kurumsal() {
  useReveal(true);
  return (
    <Layout>
      <section className="sayfa-basi">
        <div className="veri bel">Kurumsal</div>
        <h1 className="h-dev bel" style={{ margin: "14px 0 30px", maxWidth: "16ch" }}>Az sayıda, nitelikli iş</h1>
        <div className="manifesto" style={{ padding: 0, marginBottom: 60 }}>
          <p className="bel">Özalp İnşaat, İstanbul Anadolu Yakası'nda konut geliştirir. <em>40 projeli dev bir firma değiliz</em> — başladığımız her işi bitiriyoruz.</p>
        </div>
      </section>
      <section style={{ paddingTop: 0 }}>
        <div className="bolum-basi"><h2 className="h-orta bel">Yaklaşımımız</h2></div>
        <div className="olanaklar bel">
          <div><span>01</span>Söz verdiğimiz tarihte teslim etmek</div>
          <div><span>02</span>Binaların kendi malzemesinden gelen dürüst bir tasarım dili</div>
          <div><span>03</span>Taş kaplama, bal rengi ahşap, antrasit doğrama</div>
          <div><span>04</span>Teslimden sonra da yanında olmak</div>
        </div>
      </section>
      <section style={{ paddingTop: 0 }}>
        <div className="bolum-basi"><h2 className="h-orta bel">Ekip</h2></div>
        <div className="rakamlar bel">
          <div><b>Özalp</b><span className="veri">Kurucu</span></div>
          <div><b>Proje</b><span className="veri">Mimari & mühendislik</span></div>
          <div><b>Satış</b><span className="veri">Anadolu Yakası</span></div>
          <div><b>Saha</b><span className="veri">Şantiye yönetimi</span></div>
        </div>
      </section>
    </Layout>
  );
}
